import { AppContext } from "../core/context";

export function adjustCameraView(ctx: AppContext, camera: BABYLON.ArcRotateCamera, rootMesh: BABYLON.Node, scene: BABYLON.Scene, alpha?: number | undefined, beta?: number | undefined, radius?: number | undefined, minRadius?: number) {
   
    if (!rootMesh) 
        return;

    const { min, max } = rootMesh.getHierarchyBoundingVectors(true);     
    const bs = new BABYLON.BoundingSphere(min, max);  
    const bsCenter = bs.center;
    const bsRadius = bs.radius;
    
    camera.rebuildAnglesAndRadius();     
    camera.update();

    camera.target = bsCenter;
    camera.beta = beta;
    camera.alpha = alpha;

    const aspectRatio = scene.getEngine().getAspectRatio(camera);
    const halfMinFov = camera.fovMode === BABYLON.Camera.FOVMODE_VERTICAL_FIXED
        ? camera.fov / 2
        : Math.atan(Math.tan(camera.fov / 2) * Math.min(1, aspectRatio));
    
    let distance = bsRadius / Math.sin(halfMinFov);
    if (distance === Infinity) {
        return;
    }

    if (distance < bsRadius*2) {
        distance = bsRadius*2;
    }

    if (radius > distance) {
        distance = radius
    }

    /*if (distance > minRadius) {
        distance = initialCameraRadius
    }

    if (minRadius && distance < minRadius)
       distance = minRadius

    if (radius) {
        distance = radius;
    }*/

    camera.radius = distance;
    camera.lowerRadiusLimit = 1;
    camera.upperRadiusLimit = distance*2;
}

export function resetMainCamera(ctx: AppContext) {
    if (ctx.mainCamera) {
        ctx.mainCamera.alpha = Math.PI / 2;
        ctx.mainCamera.beta = Math.PI / 2.5;
        ctx.mainCamera.radius = ctx.initialCameraRadius;            
    }
}
